import { Directive, TemplateRef } from '@angular/core';
import { CellDef } from '../table.interfaces';

@Directive({ selector: '[itrHeaderCellDef]' })
export class ItrHeaderCellDefDirective implements CellDef {
  constructor(public template: TemplateRef<any>) {}
}
